
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/songs",
      function () {
        return require("private-next-pages/songs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/songs"])
      });
    }
  